export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8046.d644bea7.jpg";